import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CtaSection } from './CtaSection';
const bonuses = [{
  title: 'The 2026 Anti-AI Letter Vault',
  desc: 'Metro 2 coded letters that bypass human & robotic filters',
  value: '$97.00',
  image: 'https://cdn.magicpatterns.com/uploads/c7GJWLcJsPk3YwqZkEHzjt/Bonus_1.png',
  alt: 'Letter Vault 2026 — Anti-AI Dispute Letters'
}, {
  title: 'Secondary Data Inhibition Guide',
  desc: 'Go invisible to LexisNexis and SageStream',
  value: '$67.00',
  image: 'https://cdn.magicpatterns.com/uploads/74RWqLgYTcwVw5NU5WPayJ/Bonus_2.png',
  alt: 'Data Shield — Secondary Data Inhibition Guide'
}, {
  title: 'The 0% APR Capital Roadmap',
  desc: 'Secure cards with 18 months of no interest',
  value: '$97.00',
  image: 'https://cdn.magicpatterns.com/uploads/tismFACmsuaY1vWaWmwJLB/Bonus_3.png',
  alt: '0% APR Capital Roadmap'
}, {
  title: 'Business Credit Blueprint',
  desc: "Build business credit that doesn't report to your personal name",
  value: '$47.00',
  image: 'https://cdn.magicpatterns.com/uploads/oi84SactKVcYaPyanHhCqg/Bonus_4.png',
  alt: 'Business Credit Blueprint'
}, {
  title: 'Weekly Dispute Tracker',
  desc: 'The tool to organize your legal attack step by step',
  value: '$47.00',
  image: 'https://cdn.magicpatterns.com/uploads/6nTmJKewp3msihGAECJF1a/Bonus_5.png',
  alt: 'Success Tracker — Weekly Dispute Organizer'
}];
export function ValueStackSection() {
  return <section className="py-20 px-4" style={{
    backgroundColor: '#080808'
  }} data-id="element-267">
      <div className="max-w-4xl mx-auto" data-id="element-268">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="rounded-3xl p-1" style={{
        background: 'linear-gradient(135deg, #C5A059, #a8863a, #C5A059)'
      }} data-id="element-269">
          <div className="bg-[#0c0c12] rounded-[22px] p-8 md:p-12" data-id="element-270">
            {/* Gold heading */}
            <h2 className="text-center text-3xl md:text-4xl lg:text-5xl font-extrabold mb-10 leading-tight" style={{
            color: '#C5A059',
            fontFamily: "'Space Grotesk', sans-serif"
          }} data-id="element-271">
              Everything you get today for only $47
            </h2>

            {/* Centered product image */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.15
          }} className="flex justify-center mb-14" data-id="element-272">
              <div className="relative max-w-2xl w-full" data-id="element-273">
                <div className="absolute inset-0 rounded-2xl blur-[50px] opacity-30 pointer-events-none" style={{
                background: 'radial-gradient(ellipse at center, rgba(0, 242, 255, 0.3), transparent 70%)'
              }} data-id="element-274" />
                <img src="https://cdn.magicpatterns.com/uploads/9SujJMum34hEmpU4atK8fR/heylloyd-image-1775160656545.png" alt="Elite Mastery Bundle 2026 — Everything Included" className="relative w-full h-auto rounded-xl object-cover" style={{
                boxShadow: '0 6px 40px rgba(0, 242, 255, 0.15)'
              }} data-id="element-275" />
              </div>
            </motion.div>

            {/* Bonus cards with images */}
            <div className="space-y-8 mb-14" data-id="element-276">
              {bonuses.map((bonus, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 15
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.1 + index * 0.08
            }} whileHover={{
              boxShadow: '0 0 25px rgba(0, 242, 255, 0.08), 0 0 50px rgba(0, 242, 255, 0.04)',
              borderColor: 'rgba(0, 242, 255, 0.25)'
            }} className="flex flex-col sm:flex-row items-center gap-7 bg-[#0a0a10] border border-white/5 rounded-2xl p-7 transition-colors overflow-hidden cursor-default" data-id="element-277">
                  {/* Bonus image */}
                  <div className="relative w-full sm:w-52 md:w-60 flex-shrink-0" data-id="element-278">
                    <div className="absolute inset-0 rounded-xl blur-[25px] opacity-25 pointer-events-none" style={{
                  background: 'radial-gradient(ellipse at center, rgba(0, 242, 255, 0.35), transparent 70%)'
                }} data-id="element-279" />
                    <img src={bonus.image} alt={bonus.alt} className="relative w-full h-auto rounded-xl object-cover" style={{
                  boxShadow: '0 4px 25px rgba(0, 242, 255, 0.12), 0 0 10px rgba(197, 160, 89, 0.08)'
                }} data-id="element-280" />
                  </div>

                  {/* Bonus text */}
                  <div className="flex-1 text-center sm:text-left" data-id="element-281">
                    <div className="flex flex-wrap items-center justify-center sm:justify-start gap-2 mb-2" data-id="element-282">
                      <CheckCircle2 className="w-5 h-5 flex-shrink-0" style={{
                    color: '#00F2FF'
                  }} data-id="element-283" />
                      <span className="text-white font-bold text-lg" style={{
                    fontFamily: "'Space Grotesk', sans-serif"
                  }} data-id="element-284">
                        {bonus.title}
                      </span>
                      <span className="text-gray-500 text-sm" data-id="element-285">
                        (Value: {bonus.value})
                      </span>
                    </div>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-286">
                      {bonus.desc}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            {/* Divider */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-[#C5A059]/40 to-transparent mb-10" data-id="element-287" />

            {/* CTA */}
            <CtaSection showTrustBadges={true} data-id="element-288" />
          </div>
        </motion.div>
      </div>
    </section>;
}